import React from 'react';
import { Text, TextProps } from '@mantine/core';
import { H2SemiBold as H2SemiBoldStyle } from 'theme/typography';

interface H2SemiBoldProps extends TextProps {
  customStyle?: React.CSSProperties;
  children: React.ReactNode; // Explicitly define the children prop
}

/**
 * Applies the H2SemiBold typography style.
 */
const H2SemiBold: React.FC<H2SemiBoldProps> = ({ children, customStyle, ...restProps }) => {
  return (
    <Text {...restProps} style={{ ...H2SemiBoldStyle, ...customStyle }}>
      {children}
    </Text>
  );
};

export default H2SemiBold;
